export { default } from './MovePageMenu';
